import React from 'react';

import InnerBanner from './innerBanner';
const Contact = (props) => {
    const content = props.content;
    return (<div className="contactus-pg">
        {/* inner-banner section start */ }
        <InnerBanner
            banner_cta_button={ content.banner_cta_button }
            banner_image={ content.banner_image }
            banner_info={ content.banner_info }
            banner_title={ content.banner_title }
        />
        <div className='socialboxs'>
            <div className='container'>
                <div className="row-wrap">

                    {
                        !!content.contact_info.length && content.contact_info.map((obj, index) => {
                            return (
                                <div className="box-12 box-md-auto item-box" key={ index }>
                                    <div className="inner-box">
                                        {
                                            obj.image &&
                                            <div className="img-box">
                                                <figure>
                                                    <img src={ obj.image.url } alt="ime-contact" />
                                                </figure>
                                            </div>
                                        }
                                        <div className="info-box" dangerouslySetInnerHTML={ { __html: obj.info } } />
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>

    </div>);
};

export default Contact;